const hasInventory = (ad) => Number(ad?.estoque) > 0

const hasSellingPrice = (ad) => Number(ad?.preco?.por) > 0

export const isAdAvailable = (ad) => hasInventory(ad) && hasSellingPrice(ad)

const isAdUnavailable = (ad) => !isAdAvailable(ad)

const isNotNull = (ad) => Boolean(ad)

export function getBuyboxWinnerAd(ads) {
  if (!ads?.length) return undefined

  return ads.find(isAdAvailable) ?? ads[0]
}

/**
 * Cotação de retirada só do anúncio vendável. A simulação cota todos, e
 * retirada por um zerado exibe "Retirar por R$ 0,00" e o manda ao carrinho.
 */
export function findPickUpQuote(quoteSimulationResponses, ads) {
  return quoteSimulationResponses?.find(
    (quote) =>
      !!quote?.lojas_retirada?.length &&
      ads?.some((ad) => ad.id === quote.id_anuncio && isAdAvailable(ad))
  )
}

export function getSortedAdsWithQuoteSimulationData(
  ads,
  quoteSimulationResponses = []
) {
  const unavailableAds = ads.filter(isAdUnavailable)
  const availableAds = ads.filter(isAdAvailable)

  const findAdById = (adId, ads) => ads.find((ad) => ad.id === adId)

  const mapQuoteSimulationResponseToAd = (quoteSimulationResponse) => {
    const ad = findAdById(quoteSimulationResponse.id_anuncio, availableAds)
    return ad
      ? {
          ...ad,
          frete: quoteSimulationResponse?.erro ? null : quoteSimulationResponse,
        }
      : null
  }

  const filterAds = (quoteSimulationResponses, availableAds) => {
    const adsWithQuotes = quoteSimulationResponses
      .map(mapQuoteSimulationResponseToAd)
      .filter(isNotNull)

    const swapElements = (array, indexToBeReplaced, indexToReplace) => {
      array[indexToBeReplaced] = array.splice(
        indexToReplace,
        1,
        array[indexToBeReplaced]
      )[0]
    }

    const indexOnlyPickUp = adsWithQuotes.findIndex(
      (ad) =>
        ad.frete?.opcoes?.length === 1 && !!ad.frete?.lojas_retirada?.length
    )

    if (adsWithQuotes.length > 1 && indexOnlyPickUp === 0)
      swapElements(adsWithQuotes, 0, 1)

    return adsWithQuotes.length > 0 ? adsWithQuotes : availableAds
  }

  const sortedAvailableAds =
    quoteSimulationResponses && quoteSimulationResponses.length > 0
      ? filterAds(quoteSimulationResponses, availableAds)
      : availableAds

  return sortedAvailableAds.concat(unavailableAds)
}
